import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";

const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  edu,
  handleCancelClick,
  increment,
  counter,
  setEduId,
  eduOptions,
}) => {
  const [newEdu, setNewEdu] = useState(edu);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewEdu((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "education/" + newEdu.id + "/",
          newEdu,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setEduId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  return (
    <tr>
      <td>
        <select
          name="education_type"
          onChange={handleChange}
          value={newEdu.education_type}
        >
          <option key="0" value="" selected>
            בחר השכלה
          </option>
          {eduOptions?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="text"
          name="mosad_name"
          className="form-control"
          id="mosad_name"
          value={newEdu.mosad_name}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="city"
          className="form-control"
          id="city"
          value={newEdu.city}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="subject"
          className="form-control"
          id="subject"
          value={newEdu.subject}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="number"
          name="edu_num"
          className="form-control"
          id="edu_num"
          value={newEdu.edu_num}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="number"
          name="end_year"
          className="form-control"
          id="end_year"
          min="1900"
          max="2222"
          value={newEdu.end_year}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="diploma"
          className="form-control"
          id="diploma"
          value={newEdu.diploma}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
